import React from "react";
import contextProvider from "app/contextProvider";
import { withRouter } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";
import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
import ReactOTable from "app/_L1_components/Elements/ReactOTable";

class GroupList extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      fullGroupList: [],
      fullData: {},
      selectedGroup: "",
      selectedData: [],
      opened: false,
    };
    super(props, initState);
    this.apiStore = null;
    this.actionsShelf = null;
    this._REFRESH_TOUT = null;
    this._LOADING_ENABLED = true;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    if (
      !this.getAppContext().isCloud() ||
      this.getAppContext().authHandler.getAccountData().ExternalLogin == "no" ||
      this.getAppContext().authHandler.getAccountData().type != "ADMIN"
    ) {
      this.getAppContext().redirectTo("/web");
    }
    this.apiStore = this.getAppContext().getApiStoreService();
    this.getGropupList();
  }

  onComponentWillUnmount() {}

  toggle() {
    this.setState({
      opened: !this.state.opened,
    });
  }

  getGropupList() {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("get_group_list", {
          ___onSuccess: (status, data) => {
            let groupList = Object.keys(data).sort();
            let fullData = data;
            this.setState({
              fullGroupList: groupList,
              fullData: fullData,
              selectedGroup: groupList[0],
              selectedData: fullData[groupList[0]],
              loading: false,
            });
          },
        });
      }
    );
  }

  onRender() {
    return (
      <Section designType="narrow" className="mt-3">
        <_LoadingWrapper loadingPlug={this.state.loading && this._LOADING_ENABLED}>
          {this.state.fullData ? (
            <div>
              <div className="d-flex py-1">
                <div className="flex-shrink-1 mr-3" style={{ fontSize: "40px" }}>
                  <div style={{ display: "inline-block" }}>
                    <h5 className="ml-2">Group list</h5>
                  </div>
                </div>
                <div className="ml-auto mt-3">
                  <Dropdown
                    isOpen={this.state.opened}
                    toggle={this.toggle.bind(this)}
                    direction="down"
                    size="md"
                  >
                    <DropdownToggle className="btn btn-white button-select-logcat">
                      <div className="d-flex">
                        <div className="flex-grow-1 text-truncate">
                          <span> {this.state.selectedGroup}</span>
                        </div>
                        <div>
                          <span className="caret icon-caret-down"></span>
                        </div>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu>
                      {this.state.fullGroupList.map((val, id) => {
                        return (
                          <DropdownItem
                            onClick={() => {
                              this.setState({
                                selectedGroup: val,
                                selectedData: this.state.fullData[val],
                              });
                            }}
                            key={id}
                            active={this.state.selectedGroup == val}
                          >
                            <span>{val}</span>
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
              <Panel bodyClassName="p-0" rounded>
                <div>
                  <_LoadingWrapper loadingPlug={this.state.loading_probes}>
                    <ReactOTable
                      thClassName="px-3 py-1"
                      tdClassName="align-middle px-3 py-2"
                      compressed={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                      }
                      // compressedRowRendering={(row_items) => {
                      //   return (
                      //     <div>
                      //       <div className="mt-2">
                      //         <div className="text-muted">
                      //           <small className="">
                      //             <strong>{row_items.probes.title}</strong>
                      //           </small>
                      //         </div>
                      //         {row_items.probes.content}
                      //       </div>
                      //       <div className="mt-2">
                      //         <div className="text-muted">
                      //           <small className="">
                      //             <strong>{row_items.measures_conf.title}</strong>
                      //           </small>
                      //         </div>
                      //         {row_items.measures_conf.content}
                      //       </div>
                      //       <div className="mt-2">
                      //         <div className="text-muted">
                      //           <small className="">
                      //             <strong>{row_items.probe_status.title}</strong>
                      //           </small>
                      //         </div>
                      //         {row_items.probe_status.content}
                      //       </div>
                      //       <div className="mt-2">{row_items.ctrl.content}</div>
                      //     </div>
                      //   );
                      // }}
                      thDividers
                      cols={[
                        {
                          title: "PROBE",
                          data_key: "probe",
                          align: "center",
                          width: "100",
                          sortable: true,
                        },
                      ]}
                      defaultSort={[
                        {
                          data_key: "probe",
                          order: "asc",
                        },
                      ]}
                      rows={(() => {
                        let _TMP = [];
                        this.state.selectedData.forEach((_Curr, _Id) => {
                          _TMP.push({
                            probe: {
                              value: _Curr.name,
                              render: (
                                <div>
                                  <h5>{_Curr.name}</h5>
                                  <span className="sub-title">{_Curr.mac_address}</span>
                                </div>
                              ),
                            },
                          });
                        });
                        return _TMP;
                      })()}
                    />
                  </_LoadingWrapper>
                </div>
              </Panel>
            </div>
          ) : null}
        </_LoadingWrapper>
      </Section>
    );
  }
}

export default contextProvider(
  withRouter(GroupList),
  //	withDefinedContext(Account, 'Account', context_exposed_methods),
  {
    define: null,
  }
);
